<template>
    <v-slide-x-transition mode="out-in">
        <v-container v-if="showComponent" style="max-width: 600px">
            <CardTitle
                :title="$t('login.title')"
                :link="{ href: '/register', text: $t('login.noAccount') }"
            />
            <v-card class="pa-5 mt-2">
                <v-card-text>
                    <v-form @submit.prevent="handleLogin">
                        <v-text-field
                            data-cy="login-email"
                            v-model="email"
                            :label="$t('login.email')"
                            required
                        ></v-text-field>
                        <v-text-field
                            data-cy="login-password"
                            v-model="password"
                            :label="$t('login.password')"
                            type="password"
                            required
                        ></v-text-field>
                        <TextLink
                            :link="{
                                href: '/request-reset-password',
                                text: $t('login.forgotPassword'),
                            }"
                        />
                    </v-form>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn data-cy="login-submit" variant="flat" @click="handleLogin"
                        >{{ $t("login.login") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </v-slide-x-transition>
</template>

<script>
import { mapActions } from "vuex";
import LanguageSelector from "@/components/LanguageSelector.vue";
import CardTitle from "@/components/registration/CardTitle.vue";
import {
    startUpdateWatcher,
    showAlertModal,
    startSessionWatcher,
} from "@/utils";
import TextLink from "@/components/registration/TextLink.vue";
import { clearLogoutFlag } from "@/api";

export default {
    components: { TextLink, LanguageSelector, CardTitle },
    mounted() {
        this.showComponent = true;
    },
    data() {
        return {
            showComponent: false,
            email: "",
            password: "",
        };
    },
    methods: {
        ...mapActions("auth", ["login"]),
        showAlertModal,
        async handleLogin() {
            clearLogoutFlag();
            const response = await this.login({
                email: this.email,
                password: this.password,
            });

            /* ---------- success ---------- */
            if (response.access) {
                if (response.user) {
                    sessionStorage.setItem(
                        "user",
                        JSON.stringify(response.user)
                    );
                    startUpdateWatcher();
                    startSessionWatcher();
                }
                this.$router.replace(
                    this.$route.query.redirect || "/dashboard"
                );
                return;
            }

            /* ---------- failure ---------- */
            console.error("Login error:", response);
            let message = this.$t("common.unexpectedError"); // fallback

            if (response.response) {
                const { status, data } = response.response;

                /* company inactive (403) ----------------------------------- */
                if (
                    status === 403 &&
                    data?.error?.includes("company's account is disabled")
                ) {
                    message = this.$t("login.companyInactive");

                    /* invalid credentials (400) -------------------------------- */
                } else if (status === 400 && data?.error) {
                    message = this.$t("login.invalid"); // you already have this key

                    /* any other structured error ------------------------------ */
                } else if (data?.detail) {
                    message = data.detail;
                }
            }

            this.showAlertModal(
                this.$store,
                message,
                "danger",
                12000,
                response
            );
        },
    },
};
</script>
